import { alpha, createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0B72D9', dark: '#064A95', light: '#4BA5F5', contrastText: '#FFFFFF' },
    secondary: { main: '#F5C518', dark: '#C99A00', contrastText: '#07182D' },
    background: { default: '#F4F7FB', paper: '#FFFFFF' },
    text: { primary: '#07182D', secondary: '#5B6B7F' },
    success: { main: '#15825B' },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: 'Inter, "Segoe UI", Arial, sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.045em' },
    h2: { fontWeight: 800, letterSpacing: '-0.035em' },
    h3: { fontWeight: 800, letterSpacing: '-0.03em' },
    h4: { fontWeight: 800, letterSpacing: '-0.02em' },
    h5: { fontWeight: 750, letterSpacing: '-0.015em' },
    button: { fontWeight: 750, textTransform: 'none', letterSpacing: '0.01em' },
  },
  components: {
    MuiCssBaseline: { styleOverrides: { body: { backgroundColor: '#F4F7FB' }, '::selection': { backgroundColor: alpha('#F5C518', 0.45), color: '#07182D' } } },
    MuiButton: { styleOverrides: { root: { borderRadius: 999, paddingInline: 22, minHeight: 44, boxShadow: 'none' }, contained: { '&:hover': { boxShadow: '0 10px 28px rgba(11,114,217,.25)' } } } },
    MuiCard: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiTextField: { defaultProps: { variant: 'outlined' } },
  },
});

export default theme;
